
import HelpIcon from '~/components/ui/icons/HelpIcon.vue';

export default {
  name: 'HeaderHelp',
  fetchOnServer: false,
  components: { HelpIcon },
};
